export const TICKETS_LIST = 'ROLE_Ticket_collection_get';
export const TICKETS_CREATE = '';
export const TICKETS_SHOW = 'ROLE_Ticket_item_get';
export const TICKETS_EDIT = '';
export const TICKETS_DELETE = '';